import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxSwitchInputComponent } from './ngx-switch-input.component';

@NgModule({
  imports: [CommonModule],
  declarations: [NgxSwitchInputComponent],
  exports: [NgxSwitchInputComponent]
})
export class NgxSwitchInputModule { }
